import ReportView from "../ReportView.vue";

export const reportRoutes = [
  {
    path: "/report",
    name: "report",
    component: ReportView,
    beforeEnter: (to, from, next) => {
      if (!localStorage.__access) next({ name: "login" });
      next();
    },
    meta: {
      key: "view_rep",
    },
  },
];
